import {
	EVENT_ACTION_ADD_VEHICLE_SCREEN,
	EVENT_ACTION_EDIT_VEHICLE_SCREEN,
	EVENT_CATEGORY_VEHICLE_MANAGEMENT,
	trackCustomEvent,
} from '../../../../shared/analytics';

// Fired whenever the add/edit vehicle dialog becomes visible
export function trackVehicleDialog(dialogMode: 'add' | 'edit') {
	trackCustomEvent({
		category: EVENT_CATEGORY_VEHICLE_MANAGEMENT,
		action:
			dialogMode === 'add'
				? EVENT_ACTION_ADD_VEHICLE_SCREEN
				: EVENT_ACTION_EDIT_VEHICLE_SCREEN,
	});
}
